module.exports = __webpack_public_path__ + "b2a3ec21530592505b4fe061e740f534.svg";